import { i18n } from '@lt/localization';
import React from 'react';

import MultichoiceFilterGroup from '../../../../../../../components/Filters/components/MultichoiceFilterGroup';
import type { ExtendedFilterInfo, CommonFilterProps } from '../types';

const FilterFlightClass = (props: CommonFilterProps) => {
  const { isMobile } = props;
  return (
    <MultichoiceFilterGroup
      {...props}
      isCollapsible={!isMobile}
      Filter={FilterFlightClass}
    />
  );
};

const filterNames = {
  business: i18n.t('checkout.filter.flightClass.business'),
  econom: i18n.t('checkout.filter.flightClass.economy'),
};

FilterFlightClass.getFilterVisibleName = (
  filterOptionData: ExtendedFilterInfo,
) => filterOptionData.id && filterNames[filterOptionData.id];

FilterFlightClass.filterName = 'flight_classes';
FilterFlightClass.filterLabel = i18n.t('checkout.filter.flightClass.label');

export default FilterFlightClass;
